export default "__VITE_ASSET__d6e50ed9__"